import gql from 'graphql-tag'

// Fragment used to update cache information for the frontend
export const BASE_FRAGMENT_FOR_DIALOG_MUTATIONS = gql`
  fragment BaseFragmentForDialogMutations on Dialog {
    localId
    globalId
    irrelevant
    dialogType
    isUnanswered
  }
`
